import { createSlice } from "@reduxjs/toolkit";
import {
    getEvents,
    addEvents,
    updateEvents,
    deleteEvents,
    getCalendar,
    getUserEvent,
    checkUserAvailable,
    getCalendarByUser,
    getWorkingHourUSer,
    updateWorkingHourUSer
} from './thunk';
import { Events } from "Common/data/calendar";

export const initialState = {
    event: Events,
    calendar: {},
    errors: null,
    userEvents: [],
    userFreeSlots: [],
    workingHours: [],
    loading: false,
    breakingTime: {},
};

const CalendarSlice = createSlice({
    name: 'Calendar',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getEvents.fulfilled, (state: any, action: any) => {
            state.event = action.payload;
        });
        builder.addCase(getEvents.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(getEvents.pending, (state) => {
        })
        builder.addCase(addEvents.fulfilled, (state: any, action: any) => {
            state.event = [...state.event, action.payload]
        });
        builder.addCase(addEvents.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(addEvents.pending, (state) => {
        })
        builder.addCase(updateEvents.fulfilled, (state: any, action: any) => {
            state.event = state.event.map((event: any) =>
                event.id === action.payload.id
                    ? { ...event, ...action.payload }
                    : event
            );
        });
        builder.addCase(updateEvents.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(updateEvents.pending, (state) => {
        })
        builder.addCase(deleteEvents.fulfilled, (state: any, action: any) => {
            state.event = state.event.filter(
                (event: any) => event.id.toString() !== action.payload.toString()
            );
        });
        builder.addCase(deleteEvents.rejected, (state: any, action: any) => {
            state.error = action.payload.error || null;
        });
        builder.addCase(deleteEvents.pending, (state) => {
        })

        builder.addCase(getCalendar.fulfilled, (state: any, action: any) => {
            state.calendar = action.payload;
            state.event = action.payload.events;
        });
        builder.addCase(getCalendar.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
        });
        builder.addCase(getCalendar.pending, (state) => {
        })

        builder.addCase(getUserEvent.fulfilled, (state: any, action: any) => {
            state.userEvents = action.payload;
            state.loading = false;
        });
        builder.addCase(getUserEvent.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
            state.loading = false;
        });
        builder.addCase(getUserEvent.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(checkUserAvailable.fulfilled, (state: any, action: any) => {
            state.userFreeSlots = action.payload;
        });
        builder.addCase(checkUserAvailable.rejected, (state: any, action: any) => {
            state.userFreeSlots = action?.payload?.error || null;
        });
        builder.addCase(checkUserAvailable.pending, (state) => {
        })

        builder.addCase(getCalendarByUser.fulfilled, (state: any, action: any) => {
            state.calendar = action.payload;
            state.event = action.payload.events;
        });
        builder.addCase(getCalendarByUser.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
        });
        builder.addCase(getCalendarByUser.pending, (state) => {
        })

        builder.addCase(getWorkingHourUSer.fulfilled, (state: any, action: any) => {
            state.workingHours = action.payload.workingHours;
            state.breakingTime = action.payload.breakingTime;
            state.loading = false;
        });
        builder.addCase(getWorkingHourUSer.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
            state.loading = false;
        });
        builder.addCase(getWorkingHourUSer.pending, (state) => {
            state.loading = true;
        })

        builder.addCase(updateWorkingHourUSer.fulfilled, (state: any, action: any) => {
            state.workingHours = action.payload?.workingHours;
            state.breakingTime = action.payload?.breakingTime;
        });
        builder.addCase(updateWorkingHourUSer.rejected, (state: any, action: any) => {
            state.error = action?.payload?.error || null;
        });
        builder.addCase(updateWorkingHourUSer.pending, (state) => {
        })
    }
});

export default CalendarSlice.reducer;